import { render, staticRenderFns } from "./CurriculumStudentView.vue?vue&type=template&id=18c02cad&scoped=true&"
import script from "./CurriculumStudentView.vue?vue&type=script&lang=ts&"
export * from "./CurriculumStudentView.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumStudentView.vue?vue&type=style&index=0&id=18c02cad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c02cad",
  null
  
)

export default component.exports